module.exports = __webpack_public_path__ + "img/gok.381c17b4.png";